<template>
  <div class="w-full">
    <div class="bg-gray-100 pt-5">
      <div class="pb-5" v-html="i18n.banner" v-if="i18n.banner"></div>
      <get-started :i18n="i18n" />
      <div class="p-5 flex justify-between items-center">
        <div class="pr-5" v-html="i18n.doc"></div>
        <div class="flex justify-center">
          <ranch-button
            :label="i18n.doc_button"
            icon="book"
            :endpoint="doc_endpoint"
            action="action-secondary"
            class="w-56"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetStarted from "../Application/GetStarted.vue";

export default {
  components: { GetStarted },
  computed: {
    i18n() {
      return this.$store.state.dashboard.i18n.welcome;
    },
    doc_endpoint() {
      return (
        "https://www.ranchcomputing.com/" +
        (this.$route.params.locale == "en" ? "en/" : "") +
        "documentation/"
      );
    },
  },
};
</script>
